import { RouteRecordRaw } from 'vue-router'
import InitialDropTargetView from '@/views/InitialDropTargetView.vue';
import AdLand from '@/views/AdLand.vue';

export const routes: Array<RouteRecordRaw> = [
    {
        path: '/',
        name: 'home',
        component: InitialDropTargetView
    },
    {
        path: '/impose',
        name: 'impose',
        component: () => import('../views/Home.vue')
    },
    {
        path: '/about',
        name: 'about',
        component: () => import('../views/About.vue')
    },
    {
        path: '/help',
        name: 'Help',
        component: () => import('../views/Help.vue')
    },
    {
        path: '/helpfor',
        name: 'Help For',
        component: () => import('pdfsnake-commonui/views/HelpFor.vue')
    },
    {
        path: '/terms',
        name: 'Terms & Conditions',
        component: () => import('../views/Terms.vue')
    },
    {
        path: '/privacy',
        name: 'Privacy',
        component: () => import('../views/Privacy.vue')
    },
    {
        path: '/account',
        name: 'Account',
        component: () => import('../views/Account.vue')
    },
    {
        path: '/rustlibs',
        name: 'Rust Libs',
        component: () => import('../views/RustLibs.vue')
    },
    {
        path: '/jslibs',
        name: 'Javascript Libs',
        component: () => import('../views/JavascriptLibs.vue')
    },
    {
        path: '/endorse',
        name: 'Endorsement Guide',
        component: () => import('../views/Endorse.vue')
    },
    {
        path: '/licensing',
        name: 'Licensing',
        component: () => import('../views/Licensing.vue')
    },
    {
        path: '/enterprise',
        name: 'Enterprise',
        component: () => import('../views/Enterprise.vue')
    },
    {
        path: '/paddle',
        name: 'ManagePaddle',
        component: () => import('../views/Paddle.vue')
    },
    {
        path: '/adland',
        name: 'AdLand',
        component: AdLand
    },
    {
        path: '/cli',
        name: 'CLI',
        component: () => import('../views/CommandLineInterface.vue')
    },
    {
        path: '/clieula',
        name: 'CLIEULA',
        component: () => import('../components/CliEula.vue')
    },
    {
        path: '/api',
        name: 'Api',
        component: () => import('../views/WebApi.vue')
    },
    {
        path: '/make',
        name: 'Make',
        component: () => import('../views/MakeApi.vue')
    },
    {
        path: '/zapier',
        name: 'Zapier',
        component: () => import('../views/ZapierApi.vue')
    },
    {
        path: '/export',
        name: 'Export',
        component: () => import('pdfsnake-commonui/views/ExportSavedSteps.vue')
    },
    {
        path: '/exported',
        name: 'Exported',
        component: () => import('pdfsnake-commonui/views/ExportedSavedSteps.vue')
    },
    {
        path: '/import',
        name: 'Import',
        component: () => import('pdfsnake-commonui/views/ImportSavedSteps.vue')
    },
    {
        path: '/imported',
        name: 'Imported',
        component: () => import('pdfsnake-commonui/views/ImportedSavedSteps.vue')
    },
    {
        path: '/xray',
        redirect: '/?op=xray'
    },
    {
        path: '/oidc/:provider',
        name: 'oidc',
        component: () => import('../views/Oidc.vue')
    },
    {
        path: '/refund',
        name: 'refund',
        component: () => import('../views/Refund.vue')
    },
    {
        path: '/survey2026',
        name: 'survey2026',
        component: () => import('../views/Survey2026.vue')
    },
    {
        path: '/desktop',
        name: 'desktop',
        component: () => import('../views/DownloadDesktop.vue')
    },
]
